import { cloneDeep } from "lodash";
import { ImageLayer } from "../interfaces";
import FallbackBlankImage from "../images/fallback-blank.png";

export const opacityItem = (image: ImageLayer = { src: FallbackBlankImage }, opacity: number) => {
    const newImage = cloneDeep(image);
    newImage.opacity = opacity;
    return newImage as any;
};
